import { Game, PureObserverInfo, ComponentChanged, System, GameObject, UpdateParams } from '@combos-fun/engine';
import type Renderer3DManager from './Renderer3DManager';
import type ThreeContext from './ThreeContext';

export default class Renderer3D<T extends {} = {}> extends System<T> {
  name: string;
  game: Game;
  static observerInfo: PureObserverInfo;
  observerInfo: PureObserverInfo;
  rendererManager: Renderer3DManager;
  threeContext: ThreeContext;

  constructor(params?: T) {
    super(params);
    const Ctor = this.constructor as typeof Renderer3D & { observerInfo: PureObserverInfo };
    this.observerInfo = Ctor.observerInfo;
  }

  componentChanged(_changed: ComponentChanged) {}
  rendererUpdate(_gameObject: GameObject) {}

  override update(e?: UpdateParams): void {
    const changes = this.componentObserver.clear();
    for (const changed of changes) {
      this.componentChanged(changed);
    }
  }

  protected asyncIdMap: Record<number, number> = {};

  protected increaseAsyncId(id: number) {
    this.asyncIdMap[id] = (this.asyncIdMap[id] || 0) + 1;
    return this.asyncIdMap[id];
  }

  protected validateAsyncId(id: number, asyncId: number) {
    return this.asyncIdMap[id] === asyncId;
  }
}
